import {
    FETCH_REVERSE_SORT_GROUP_PLAN_BEGIN,
    FETCH_REVERSE_SORT_GROUP_PLAN_SUCCESS,
    FETCH_REVERSE_SORT_GROUP_PLAN_FAILURE
} from "../actions/ReverseSortGroupPlanActions";

/**
 * Initial state for the Reverse Sort Group Plan view.
 */
const initialState = {
    loading: false,
    error: null,
    planDay: null,
    sortGroupPlans: []
};

/**
 * Reducer function for the Reverse Sort Group Plan view that changes state
 * based on the action triggered.
 */
export default function reverseSortGroupPlanReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_REVERSE_SORT_GROUP_PLAN_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_REVERSE_SORT_GROUP_PLAN_SUCCESS:
            return {
                ...state,
                loading: false,
                planDay: action.planDay,
                sortGroupPlans: action.sortGroupPlans
            };
        case FETCH_REVERSE_SORT_GROUP_PLAN_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/ReverseSortGroupPlanReducer.js